// extracted by mini-css-extract-plugin
module.exports = {"title":"footerMenu_title__3G7Fj","link":"footerMenu_link__2uBQn"};
    if(module.hot) {
      // 1785568561748
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  